<template>
	<div class="rp-order-description">
		<div
			class="rp-order-description__basic-info rp-basic-card"
        	:class="getAnimation"
			>
			<OrderItem
				class="rp-delivery-summary-item"
				:orderData="orderDetails"
				@action="handleOrderAction"
				:actionsList="actionsList"
				:showViewButton="false"
				:showTopHeaderOnly="true"
			/>
		</div>
		<div 
			class="rp-order-description__address-info rp-basic-card"
			:class="getAnimation"
			>
			<OrderAddress 
				:orderData="orderDetails"
			/>
		</div>
		<div
			class="rp-order-description__receipt-info rp-basic-card"
			:class="getAnimation"
			>
			<OrderReceipt 
				:orderData="orderDetails"
			/>
		</div>
  	</div>
</template>

<script>
import OrderAddress from "./OrderAddress"
import OrderReceipt from "./OrderReceipt"
export default {

	props: {
		orderDetails: Object,
		activeColor: {
			type: String,
			required: true
	    },

		getAnimation: {
		type: Array,
		required: true,
    },
    scenarioAvailable: {
      type: Boolean,
      required: true,
      default: false,
    }
	},
	
	data() {
		return {
			
		}
	},

    computed: {

		actionsList(){
			let acitons = [];
			if(this.scenarioAvailable){
				acitons.push(
					{
						buttonLabel: 'help',
						actionName: 'onOrderHelpClick',
					}
				)
			}
			acitons.push(
				{
					buttonLabel: 'track',
					actionName: 'onOrderTrackUrlClick',
				}
			)
			return  acitons;
		},

		trackingURL() {
			return this.orderDetails.trackingUrl;
		},

		isFulfillmentCount() {
			return this.orderDetails.fulfillmentCount
		}
	},

	methods: {
		handleOrderAction({ actionName, payload }) {
			this.$emit(actionName, payload)
    	}
	},
    components: {
      OrderAddress,
      OrderReceipt
  	}
};
</script>
<style lang="scss" scoped>
.rp-order-description {
	margin: 16px;
	.rp-order-description__basic-info  {
    animation-delay: 100ms;
	}
	.rp-delivery-summary-item {
		cursor: initial;
		background: #f9f9f9;
    	border-radius: 4px;
	}
	.rp-order-description__address-info, .rp-order-description__receipt-info {
		margin-top: 16px;
		padding: 0px;
		animation-delay: 200ms;
	}
	.rp-order-description__receipt-info {
		animation-delay: 300ms;
	}
}
</style>
